import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getKgoZonesData(context) {
      const response = await Vue.axios.get(`${URL_API}kgozone`);
      let data = response["data"];
      context.commit("updateKgoZonesData", data);
    },
    async createKgoZoneData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}kgozone/store`, body, config);
      context.dispatch("getKgoZonesData");
    },
    async pushKgoZoneData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}kgozone/update`, body, config);
      context.dispatch("getKgoZonesData");
    },
    async destroyKgoZoneData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}kgozone/destroy`, body, config);
      context.dispatch("getKgoZonesData");
    }
  },
  mutations: {
    updateKgoZonesData(state, kgoZonesData) {
      state.kgoZonesData = kgoZonesData;
    }
  },
  state: {
    kgoZonesData: []
  },
  getters: {
    allKgoZonesData(state) {
      return state.kgoZonesData;
    }
  }
};